import React, {
  CSSProperties,
  FC,
  HTMLAttributes,
  ImgHTMLAttributes,
  TdHTMLAttributes,
} from 'react'

import cn from 'classnames'

import classes from './roaming.module.scss'

export const Para: FC<HTMLAttributes<HTMLParagraphElement>> = ({
  className,
  children,
  ...rest
}) => (
  <p className={cn(classes.para, className)} {...rest}>
    {children}
  </p>
)

export const AltPara: FC<HTMLAttributes<HTMLParagraphElement>> = ({
  className,
  children,
  ...rest
}) => (
  <p className={cn(classes.altPara, className)} {...rest}>
    {children}
  </p>
)

export const RoamingListItem: FC<HTMLAttributes<HTMLLIElement>> = ({
  className,
  children,
  ...rest
}) => (
  <li className={cn(classes.roamingListItem, className)} {...rest}>
    {children}
  </li>
)

export const Flag: FC<ImgHTMLAttributes<HTMLImageElement>> = ({
  className,
  ...rest
}) => <img className={cn(classes.flag, className)} alt="" {...rest} />

export const TopFlag: FC<ImgHTMLAttributes<HTMLImageElement>> = ({
  className,
  ...rest
}) => <img className={cn(classes.topFlag, className)} alt="" {...rest} />

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  bgColor?: string
  padding?: string
}

export const Container: FC<ContainerProps> = ({
  bgColor,
  padding,
  className,
  style,
  children,
  ...rest
}) => (
  <div
    className={cn(classes.container, className)}
    style={
      {
        ...style,
        '--container-bg': bgColor || 'transparent',
        '--container-padding': padding || '15px 0',
      } as CSSProperties
    }
    {...rest}
  >
    {children}
  </div>
)

export const RoamingList: FC<HTMLAttributes<HTMLOListElement>> = ({
  className,
  children,
  ...rest
}) => (
  <ol className={cn(classes.roamingList, className)} {...rest}>
    {children}
  </ol>
)

export const TdPricing: FC<TdHTMLAttributes<HTMLTableCellElement>> = ({
  className,
  children,
  ...rest
}) => (
  <td className={cn(classes.tdPricing, className)} {...rest}>
    {children}
  </td>
)

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  noMaxWidth?: boolean
  copyColor?: string
  headingColor?: string
}

export const Card: FC<CardProps> = ({
  noMaxWidth,
  copyColor,
  headingColor,
  className,
  style,
  children,
  ...rest
}) => (
  <div
    className={cn(
      classes.card,
      { [classes.noMaxWidth]: noMaxWidth },
      className
    )}
    style={
      {
        ...style,
        '--card-copy-color': copyColor || '#fff',
        '--card-heading-color': headingColor || '#ffd67c',
      } as CSSProperties
    }
    {...rest}
  >
    {children}
  </div>
)

export const RoamingHeading: FC<HTMLAttributes<HTMLHeadingElement>> = ({
  className,
  children,
  ...rest
}) => (
  <h1 className={cn(classes.roamingHeading, className)} {...rest}>
    {children}
  </h1>
)

export const WifiCard: FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...rest
}) => (
  <div className={cn(classes.wifiCard, className)} {...rest}>
    {children}
  </div>
)

export const SubHeading: FC<HTMLAttributes<HTMLHeadingElement>> = ({
  className,
  children,
  ...rest
}) => (
  <h3 className={cn(classes.subHeading, className)} {...rest}>
    {children}
  </h3>
)

export const Tabs: FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...rest
}) => (
  <div className={cn(classes.tabs, className)} {...rest}>
    {children}
  </div>
)

export const BreadCrumbs: FC<HTMLAttributes<HTMLParagraphElement>> = ({
  className,
  children,
  ...rest
}) => (
  <p className={cn(classes.breadCrumbs, className)} {...rest}>
    {children}
  </p>
)

export const Desktop: FC<HTMLAttributes<HTMLSpanElement>> = ({
  className,
  children,
  ...rest
}) => (
  <span className={cn(classes.desktop, className)} {...rest}>
    {children}
  </span>
)

export const Mobile: FC<HTMLAttributes<HTMLSpanElement>> = ({
  className,
  children,
  ...rest
}) => (
  <span className={cn(classes.mobile, className)} {...rest}>
    {children}
  </span>
)

interface RoamingTableProps extends HTMLAttributes<HTMLTableElement> {
  borderColor?: string
}

export const Table: FC<RoamingTableProps> = ({
  borderColor,
  className,
  style,
  children,
  ...rest
}) => (
  <table
    className={cn(classes.table, className)}
    style={
      {
        ...style,
        '--table-border-color': borderColor || '#EFC873',
      } as CSSProperties
    }
    {...rest}
  >
    {children}
  </table>
)

export const RoamingParagraph: FC<HTMLAttributes<HTMLParagraphElement>> = ({
  className,
  children,
  ...rest
}) => (
  <p className={cn(classes.roamingParagraph, className)} {...rest}>
    {children}
  </p>
)

export const ButtonContainer: FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...rest
}) => (
  <div className={cn(classes.buttonContainer, className)} {...rest}>
    {children}
  </div>
)
